import React, { FC } from 'react'
import { InputComponent } from 'LibNeo'
import { FieldNames } from 'Src/constants/FieldNames'
import { Validators } from 'Modules'
import { SpecialInputPropsModel } from 'LibNeo/models/'
import { onlyDigits } from 'Helpers'

export const KppInput: FC<SpecialInputPropsModel> = (props) => {
	return (
		<InputComponent
			{...props}
			fieldName={props?.fieldName || FieldNames.KPP}
			fieldOptions={{
				rules: [
					{
						validator: Validators.checkKPP({
							required: props?.required,
						}),
					},
				],
				initialValue: props?.initialValue,
				normalize: onlyDigits,
			}}
			dataQa={props?.dataQa || 'kppneo-input'}
			label={props?.label ?? 'lib.kpp'}
		/>
	)
}
